import initConnectMe from 'core/controllerConnectMe'

export default function (hcStorage) {
  initConnectMe({ placement: 'header-modal', hcStorage })
}
